import * as actionTypes from './actionTypes';
import moment from 'moment';
import { serviceHTTP } from '../util/service';
import * as spinnerActions from '../actions/spinnerActions';
import { getAccessToken } from '../util/customMethods';
import { store } from '../store/configureStore';
export const VENDOR_REPORT_REQUEST = 'VENDOR_REPORT_REQUEST';
export const VENDOR_REPORT_SUCCESS = 'VENDOR_REPORT_SUCCESS';
export const VENDOR_REPORT_FAILURE = 'VENDOR_REPORT_FAILURE';
// SPD Report action types (Response Report without Late information)
export const VENDOR_REPORT_SPD_REQUEST = 'VENDOR_REPORT_SPD_REQUEST';
export const VENDOR_REPORT_SPD_SUCCESS = 'VENDOR_REPORT_SPD_SUCCESS';
export const VENDOR_REPORT_SPD_FAILURE = 'VENDOR_REPORT_SPD_FAILURE';
const createObject = (invoiceId, reason) => ({
    invoiceId: invoiceId,
    serviceCallId: null,
    callStatus: "Cancel",
    reason: reason,
    statusValue: "Edit"
});

export const setInvoiceSelectedDate = (year, month, date) => {
    return (dispatch) => {
        dispatch(clearSearchInvoice());
        dispatch(
            {
                type: actionTypes.SET_INVOICE_SELECTED_DATE,
                invoiceSelectedDate: {
                    selectedYear: year,
                    selectedMonth: month === 0 ? '' : month,
                    selectedDate: date === 0 ? '' : date
                }
            });


    }
};

export const getInvoiceMonthYears = (userId) => {
    const _url = 'getDataofyearAndMonth?userId=' + userId
    return (dispatch) => {
        dispatch(spinnerActions.showSpinner());
        return serviceHTTP.get(_url, undefined, getAccessToken())
            .then(response => {
                if (response.error == undefined) {
                    dispatch({
                        type: actionTypes.GET_INVOICE_MONTH_YEARS,
                        invoiceMonthYears: formatInvoiceMonthYears(response, dispatch, userId)
                    });
                } 
                dispatch(spinnerActions.hideSpinner());
            })
            .catch(error => {
                dispatch(spinnerActions.hideSpinner());
                throw (error);
            });

    }
}

export const getInvoicesData = (userId, silent = false) => {
    const _url = 'invoices?userId=' + userId
    return (dispatch) => {
        if (!silent) dispatch(spinnerActions.showSpinner());
        return serviceHTTP.get(_url, undefined, getAccessToken())
            .then(response => {
                if (!silent) dispatch(spinnerActions.hideSpinner());
                if (response.status === 200) {
                    dispatch({
                        type: actionTypes.INVOICESDATA,
                        invoices: response || []
                    });
                } 
            })
            .catch(error => {
                if (!silent) dispatch(spinnerActions.hideSpinner());
                console.error("Error fetching invoices data:", error);
            });
    }
}

export const cancelInvoice = (invoiceId, reason) => {
    const dynamicObject = createObject(invoiceId, reason);
    const _url = '/dashboard/cancel/serviceCall';
    return (dispatch) => {
        dispatch(spinnerActions.showSpinner());
        return new Promise((resolve, reject) => {
            serviceHTTP.postToDispatch(_url, dynamicObject, undefined, getAccessToken()) 
                .then(response => {
                    dispatch(spinnerActions.hideSpinner());
                    if (response.status === 200) {
                        resolve(response); 
                    } 
                })
                .catch(error => {
                    dispatch(spinnerActions.hideSpinner());
                    console.error("Error cancelling invoice:", error);
                    reject(error); 
                });
        });
    };
};

export const searchInvoiceMetaData = (searchParams) => {
    const query = new URLSearchParams(searchParams).toString();
    const _url = `search?${query}`;
    return (dispatch) => {
        dispatch(spinnerActions.showSpinner());
        return serviceHTTP.get(_url, undefined, getAccessToken())
            .then(response => {
                dispatch(spinnerActions.hideSpinner());

                if (response.status === 200) {
                    dispatch({
                        type: actionTypes.INVOICE_SEARCH_RESULT,
                        invoiceSearchData: response || []
                    });
                    return response.data;
                } 
            })
            .catch(error => {
                dispatch(spinnerActions.hideSpinner());
                console.error("Error fetching invoices data:", error);
            });
    }
};

export const vendorReport = (start, enddate) => {
    const searchParams = { startDate: start, endDate: enddate };
    const query = new URLSearchParams(searchParams).toString();
    const _url = `vendorReport?${query}`; // Adjusted URL
    return (dispatch) => {
        dispatch(spinnerActions.showSpinner());
        return serviceHTTP.get(_url, undefined, getAccessToken())
            .then(response => {
                dispatch(spinnerActions.hideSpinner());
                if (response.status === 200) {
                    const invoiceData = response || [];
                    return invoiceData;
                } 
            })
            .catch(error => {
                dispatch(spinnerActions.hideSpinner());
                return []; // Return an empty array or appropriate error response
            });
    };
};

export const fetchInvoice = (invId) => {
    const _url = `invoice/${invId}`;
    return (dispatch) => {
        dispatch(spinnerActions.showSpinner());
        return serviceHTTP.get(_url, undefined, getAccessToken())
            .then(response => {
                dispatch(spinnerActions.hideSpinner());
                if (response.status === 200) {
                    dispatch({
                        type: actionTypes.INVOICE_DETAILS,
                        invoiceDetails: response || {}
                    });
                    return response.data;
                } 
            })
            .catch(error => {
                dispatch(spinnerActions.hideSpinner());
                console.error("Error fetching invoices data:", error);
            });
    }
};

// Update the fetchInvoiceNotes method
export const fetchInvoiceNotes = (invId) => {
    const _url = `byInvoice/${invId}`;
    return (dispatch) => {
        dispatch(spinnerActions.showSpinner());
        return serviceHTTP.get(_url, undefined, getAccessToken())
            .then(response => {
                dispatch(spinnerActions.hideSpinner());
                if (response.status === 200) {
                    dispatch({
                        type: actionTypes.INVOICE_NOTES,
                        invoicenotes: response || []
                    });
                    return response.data;
                }
            })
            .catch(error => {
                dispatch(spinnerActions.hideSpinner());
                console.error("Error fetching invoice notes:", error);
                return [];
            });
    }
};

export const saveNotes = (noteObj, id) => {
    const _url = `addOrUpdate`;
    return (dispatch) => {
        dispatch(spinnerActions.showSpinner());
        return serviceHTTP.post(_url, noteObj, undefined, getAccessToken())
            .then(response => {
                dispatch(spinnerActions.hideSpinner());
                // Check if response is JSON or handle response data properly
                if (response.status === 200) {
                    // Immediately fetch updated notes after saving
                    dispatch(fetchInvoiceNotes(id));
                    return response.data || response;
                } else {
                    throw new Error('Failed to save note');
                }
            })
            .catch(error => {
                dispatch(spinnerActions.hideSpinner());
                console.error("Error in saving notes:", error);
                throw error;
            });
    };
};


export const resetInvoiceData = () => {
    return {
        type: actionTypes.RESET_INVOICE_DATA
    };
};

export const getInvoiceList = (userId, year = 0, month = 0) => {
    const _url = 'getAttachmentDataByInputs?userId=' + userId + '&year=' + year + '&month=' + month
    return (dispatch) => {
        dispatch(spinnerActions.showSpinner());
        return serviceHTTP.get(_url, undefined, getAccessToken())
            .then(response => {
                if (response.error == undefined) {
                    dispatch({
                        type: actionTypes.GET_INVOICE_LIST,
                        invoiceList: response
                    });
                } 
                dispatch(spinnerActions.hideSpinner());
            })
            .catch(error => {
                dispatch(spinnerActions.hideSpinner());
                throw (error);
            });

    }
}

export const searchInvoice = (invNo) => {
    return (dispatch) => {
        let invList = (store.getState()).invoiceList;
        let _searchInvList = invList.filter(item => {
            return Object.keys(item.attachments).includes(invNo);
        });
        dispatch({
            type: actionTypes.SEARCH_INVOICE_NO,
            searchResult: { data: _searchInvList, isSearch: true }
        });
        if (_searchInvList.length > 0) {
            const _invDate = moment(_searchInvList[0].createdDate)
            dispatch({
                type: actionTypes.SET_INVOICE_SELECTED_DATE,
                invoiceSelectedDate: {
                    selectedYear: parseInt(_invDate.format('YYYY')),
                    selectedMonth: parseInt(_invDate.format('MM')),
                    selectedDate: parseInt(_invDate.format('DD'))
                }
            });
        }

    }
}

export const clearSearchInvoice = () => {
    return (dispatch) => {
        dispatch({
            type: actionTypes.CLEAR_SEARCH_INVOICE_NO,
            searchResult: { data: [], isSearch: false }
        })
    }

}

export const changeInvoiceView = (isTableView = false) => {
    return {
        type: actionTypes.INVOICE_VIEW_TRIGGER,
        invoiceView: { isTableView: isTableView }
    };
}

const formatInvoiceMonthYears = (list, dispatch, userId) => {
    let _formatedList = list.reduce(
        (result, item) => ({
            ...result,
            [item['year']]: [
                ...(result[item['year']] || []),
                {
                    month: item.monthName,
                    monthNo: item.month
                }
            ].sort((x, y) => { return y.monthNo - x.monthNo }),
        }),
        {},
    );
    if (Object.keys(_formatedList).length > 0) {
        let yyyy = Object.keys(_formatedList).sort((a, b) => { return b - a })[0];
        dispatch({
            type: actionTypes.SET_INVOICE_SELECTED_DATE,
            invoiceSelectedDate: {
                selectedYear: parseInt(yyyy),
                selectedMonth: parseInt(_formatedList[yyyy][0].monthNo),
                selectedDate: 0
            }
        });
        dispatch(getInvoiceList(userId, yyyy, _formatedList[yyyy][0].monthNo));
    }
    return _formatedList;
}

export const vendorRspReport = (startDate, endDate) => {
    const _url = `vendorresp/response?startDate=${startDate}&endDate=${endDate}`;
    
    return (dispatch) => {
        dispatch({ type: VENDOR_REPORT_REQUEST });
        dispatch(spinnerActions.showSpinner());
        
        return serviceHTTP.get(_url, undefined, getAccessToken())
            .then(response => {
                dispatch(spinnerActions.hideSpinner());
                
                if (response.status === 200) {
                    dispatch({
                        type: VENDOR_REPORT_SUCCESS,
                        payload: response || []
                    });
                    return response.data;
                } 
            })
            .catch(error => {
                dispatch(spinnerActions.hideSpinner());
                dispatch({
                    type: VENDOR_REPORT_FAILURE,
                    payload: error.message || "Error fetching report data"
                });
                console.error("Error fetching report data:", error);
                return [];
            });
    };
};

/**
 * NEW: Vendor Response Report for SPD (without Late information)
 * Calls optimized API endpoint that doesn't calculate late data
 */
export const vendorRspReportSPD = (startDate, endDate) => {
    const _url = `vendorresp/response-spd?startDate=${startDate}&endDate=${endDate}`;
    
    return (dispatch) => {
        dispatch({ type: VENDOR_REPORT_SPD_REQUEST });
        dispatch(spinnerActions.showSpinner());
        
        return serviceHTTP.get(_url, undefined, getAccessToken())
            .then(response => {
                dispatch(spinnerActions.hideSpinner());
                
                if (response.status === 200) {
                    dispatch({
                        type: VENDOR_REPORT_SPD_SUCCESS,
                        payload: response || []
                    });
                    return response.data;
                } 
            })
            .catch(error => {
                dispatch(spinnerActions.hideSpinner());
                dispatch({
                    type: VENDOR_REPORT_SPD_FAILURE,
                    payload: error.message || "Error fetching SPD report data"
                });
                console.error("Error fetching SPD report data:", error);
                return [];
            });
    };
};

